import { render, staticRenderFns } from "./code-card.vue?vue&type=template&id=f3132e38&scoped=true"
import script from "./code-card.vue?vue&type=script&lang=js"
export * from "./code-card.vue?vue&type=script&lang=js"
import style0 from "./code-card.vue?vue&type=style&index=0&id=f3132e38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3132e38",
  null
  
)

export default component.exports